import { clampToUnitInterval } from './clamp-to-unit-interval';
import { roundToTwoDecimals } from './round-to-two-decimals';

export const getPercentPosition = (clientX, clientY, rect) => {
  const offsetX = rect.width > 0 ? clampToUnitInterval((clientX - rect.left) / rect.width) : 0;
  const offsetY = rect.height > 0 ? clampToUnitInterval((clientY - rect.top) / rect.height) : 0;

  return {
    x: roundToTwoDecimals(offsetX * 100),
    y: roundToTwoDecimals(offsetY * 100),
  };
};
